// Govern360 product version, shown at the foot of the sidebar.
//
// BUMP THIS BY HAND on a release. It is deliberately NOT read from
// package.json: that file carries a private workspace package version
// (0.1.0) which nothing publishes or depends on, and changing it would
// be a semver claim about the package rather than about the product.
//
// Both the console and the admin app import this, so there is one
// number rather than two that drift apart.
// G360_K484 - release 1.2.3 (2026-09-25). Previous: 1.2.2 (2026-09-07).
export const APP_VERSION = '1.2.3';
